import { SurgicalCenterPage } from "@/components/SurgicalCenter/SurgicalCenterPage";
import { PageTitle } from "@/../_metronic/layout/core";

export function SurgicalCenter() {
	return (
		<>
			<PageTitle description="Leitos">Centro Cirúrgico</PageTitle>
			<SurgicalCenterPage />
		</>
	);
}
